import { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import PricingPlanFeature from 'src/entities/pricing/pricingPlanFeature';
import type LabelGroup from '../../entities/labelGroup';
import { getWorkspace } from '../../selectors/workspaces';

const DEMO_LABEL_GROUP_NAME = 'verybusy demo';

type UseWorkspaceLabelGroupsParams = {
	workspaceID: number;
};

const useWorkspaceLabelGroups = ( {
	workspaceID
}: UseWorkspaceLabelGroupsParams ) => {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-expect-error getWorkspace selector types are not properly inferred in this legacy component
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const workspace = useSelector( ( state: any ) => getWorkspace( state, { workspaceID } ) );

	const [ showNewGroupModal, setShowNewGroupModal ] = useState( false );
	const [ groupToEdit, setGroupToEdit ] = useState<LabelGroup>();

	const isFeatureAvailable = useMemo(
		() => workspace?.supportsFeature( PricingPlanFeature.LABEL_GROUPS ) || false,
		[ workspace ]
	);

	const isDemoLabelGroup = ( group: LabelGroup ): boolean => (
		group.name.toLowerCase() === DEMO_LABEL_GROUP_NAME
	);

	const shouldDisableActionsButtons = ( group: LabelGroup ): boolean => (
		isDemoLabelGroup( group ) && !isFeatureAvailable
	);

	const shouldDisableGroupRow = ( group: LabelGroup ): boolean => (
		!isFeatureAvailable && !isDemoLabelGroup( group )
	);

	const onEditGroupClick = ( group: LabelGroup ) => {
		if ( !isFeatureAvailable || shouldDisableActionsButtons( group ) ) { return; }
		setGroupToEdit( group );
	};

	const onNewGroupClick = () => {
		setShowNewGroupModal( true );
	};

	const onCloseNewGroupModal = () => {
		setShowNewGroupModal( false );
	};

	const onCloseEditGroupModal = () => {
		setGroupToEdit( undefined );
	};

	return {
		workspace,
		isFeatureAvailable,
		showNewGroupModal,
		groupToEdit,
		isDemoLabelGroup,
		shouldDisableActionsButtons,
		shouldDisableGroupRow,
		onEditGroupClick,
		onNewGroupClick,
		onCloseNewGroupModal,
		onCloseEditGroupModal
	};
};

export default useWorkspaceLabelGroups;
